import { render } from "./RomanByzantine.vue?vue&type=template&id=3e96aa8e&scoped=true"
import script from "./RomanByzantine.vue?vue&type=script&lang=js"
export * from "./RomanByzantine.vue?vue&type=script&lang=js"

import "./RomanByzantine.vue?vue&type=style&index=0&id=3e96aa8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e96aa8e"]])

export default __exports__